export default {
    title: "O-I",
    support: "Podpora",
    dashboard: "Dashboard"
}